<template>
<div></div>
</template>

<script>
import NoticeModal from '@/components/common/modals/notice-modal/notice-modal';
import Http from '../../../libs/http';

export default {
  name: '',
  components: {
  },
  props: {
    visaCountryId: Number,
    provinceCode: Number,
  },
  data() {
    return {
      // 回调
      callback: {
        resolve: null,
        reject: null,
      },
    };
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    initNoticeList() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await Http.post('/sys/notice_brief_query', {
            country_id: this.visaCountryId,
            province_code: this.provinceCode,
          });
          this.noticeList = res.result;
          if (!this.noticeList || !this.noticeList.length) return resolve();
          this.callback.resolve = resolve;
          this.callback.reject = reject;
          
          this.showNoticesAlert();
          
        } catch (error) {
          resolve();
        }
      });
    },

    // 显示国家通知的弹窗
    showNoticesAlert() {
      const noticeList = this.noticeList;
      const alertList = noticeList.filter(item => item.pop_remind === 1);
      const readNoticeList = window.localStorage.getItem('readNoticeList') ? JSON.parse(window.localStorage.getItem('readNoticeList')) : [];
      // 是否存在未读
      let hasUnread = false;
      for (let index = 0; index < alertList.length; index++) {
        const item = alertList[index];
        if (readNoticeList.indexOf(item.id) === -1) {
          hasUnread = true;
          NoticeModal.modal({
            title: item.title,
            message: item.content,
            isTextareaMessage: true,
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonText: '我知道了',
            confirmMethod: () => {
              readNoticeList.push(item.id);
              window.localStorage.setItem('readNoticeList', JSON.stringify(readNoticeList));
              setTimeout(() => {
                this.showNoticesAlert();
              }, 0);
            },
            cancelMethod: () => {
              readNoticeList.push(item.id);
              window.localStorage.setItem('readNoticeList', JSON.stringify(readNoticeList));
              setTimeout(() => {
                this.showNoticesAlert();
              }, 0);
            },
          });
          break;
        }
      }
      if (!hasUnread) {
        // 不存在未读，说明公告弹窗都结束了
        this.callback.resolve && this.callback.resolve();
      }
    },
  },
};
</script>

<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/pages/country/components/country-notice.vue